import {
  Switch,
  Route,
  Redirect
} from "react-router-dom";
import About from "./components/About/About";
import Admission from "./components/Admission/Admission";
import Home from "./components/home/Home";
import Sc from "./components/students/SportsClub";
import Department from "./components/courses/Department";
import Contact from './components/contact/Contact'
import Gallery from "./components/gallery/Gallery";
import Login from './components/Students-Portal/Login';
import SignUp from './components/Students-Portal/SignUp';
import {  ThemeProvider } from '@material-ui/core';
import { createTheme } from '@material-ui/core/styles'
import ApplicationLayout from "./components/Application/ApplicationLayout";
import AdmissionAdmin from "./components/AdminPages/Admission/AdmissionAdmin";
import AdmissionMain from "./components/AdminPages/Admission/AdmissionMain";
import AcceptedApplicants from "./components/AdminPages/Admission/AcceptedApplicants";
import { grey } from "@material-ui/core/colors";
import AdminLogIn from "./components/AdminPages/AdminLogIn";
import PersonalInfo from './components/Students-Portal/Personalnfo';
import FeesPortal from "./components/Students-Portal/FeesPortal";
import ClassesPortal from "./components/Students-Portal/ClassesPortal";
import StudentResults from "./components/Students-Portal/StudentResults";
import Bursary from "./components/AdminPages/Bursary/Bursary";
import StudentSearch  from "./components/AdminPages/Bursary/StudentSearch";
import AddFees from "./components/AdminPages/Bursary/AddFees";
import TeacherProfile from "./components/AdminPages/Teachers/TeacherProfile";
import AddClass from './components/AdminPages/Teachers/AddClass';
import AddResult from "./components/AdminPages/Teachers/AddResult";
import StudentResult from "./components/AdminPages/Teachers/StudentResult";
import NoticePage from "./components/NoticePage";
import AddExistingStudent from "./components/AdminPages/Admission/AddExistingStudent";
import AllStudents from "./components/AdminPages/Admission/AllStudents";
import AllAdmins from "./components/AdminPages/Admission/AllAdmins";
import CreateAdmin from "./components/AdminPages/Admission/CreateAdmin";
import CreateNotice from "./components/AdminPages/Admission/CreateNotice";
import Departments from "./components/courses/Departments";
import RemoveClass from "./components/AdminPages/Teachers/RemoveClass";
import NotFound from "./components/NotFound";
import MainAdminDashboard from "./components/AdminPages/Admission/MainAdminDashboard";
import BursaryDashboard from "./components/AdminPages/Bursary/BursaryDashboard";
import TeachersDashboard from "./components/AdminPages/Teachers/TeachersDashboard";
import StudentDashboard from "./components/Students-Portal/StudentDashboard";
import Bridging from "./components/courses/Bridging";
import ForgotPwd from "./components/ForgotPwd";
import AllClasses from "./components/AdminPages/Admission/AllClasses";
import AdminSignUp from "./components/AdminPages/AdminSignUp";

const theme =  createTheme({
  palette: {
    primary: {
      main: '#af0e19'
    },
    secondary: {
      main: grey[500]
    },
    
  }
});

function App() {
  return (
    <ThemeProvider theme={theme}>
        <div className="App">
          <Switch>
            <Route exact path="/">
              <Home />
            </Route>
            <Route path="/admission">
              <Admission />
            </Route>
            <Route path="/about">
              <About />
            </Route>
            <Route path="/division/:departments">
              <Departments />
            </Route>
            <Route path="/sportsAndClubs">
              <Sc />
            </Route>
            <Route path="/departments/:department">
              <Department />
            </Route>
            <Route path="/contact">
              <Contact />
            </Route>
            <Route path="/gallery">
              <Gallery />
            </Route>
            <Route path="/shortcourses">
              <Bridging />
            </Route>
            <Route path="/notice/:id">
              <NoticePage />
            </Route>
            <Route path="/online-application">
              <ApplicationLayout />
            </Route>
            <Route path="/e-portal">
              <Login />
            </Route>
            <Route exact path="/portal">
              <Login />
            </Route>
            <Route exact path="/portal-dashboard">
              <StudentDashboard />
            </Route>
            <Route exact path="/portal-create">
              <SignUp />
            </Route>
            <Route path="/portal-profile">
              <PersonalInfo />
            </Route>
            <Route exact path="/portal-fees">
              <FeesPortal />
            </Route>
            <Route exact path="/portal-courses">
              <ClassesPortal />
            </Route>
            <Route exact path="/portal-results">
              <StudentResults />
            </Route>
            <Route exact path="/admin">
              <AdminLogIn />
            </Route>
            <Route exact path="/admin-signup">
              <AdminSignUp />
            </Route>
            <Route exact path="/create-notice">
              <CreateNotice />
            </Route>
            <Route exact path="/admin-main">
              <MainAdminDashboard />
            </Route>
            <Route exact path="/admin-applications">
              <AdmissionMain />
            </Route>
            <Route exact path="/all-classes">
              <AllClasses />
            </Route>
            <Route path="/admission-admin/:id">
              <AdmissionAdmin />
            </Route>
            <Route path="/admission-accepted">
              <AcceptedApplicants />
            </Route>
            <Route path="/admission-addStudent">
              <AddExistingStudent />
            </Route>
            <Route path="/all-students">
              <AllStudents />
            </Route>
            <Route path="/admission-addAdmin">
              <CreateAdmin />
            </Route>
            <Route path="/all-admins">
              <AllAdmins />
            </Route>
            <Route exact path="/admin-bursary">
              <BursaryDashboard />
            </Route>
            <Route exact path="/bursary-students">
              <Bursary />
            </Route>
            <Route exact path="/bursary-students/:id">
              <AddFees />
            </Route>
            <Route exact path="/bursary-search">
              <StudentSearch />
            </Route>
            <Route exact path="/admin-teacher">
              <TeachersDashboard />
            </Route>
            <Route exact path="/teacher-profile">
              <TeacherProfile />
            </Route>
            <Route exact path="/add-class">
              <AddClass />
            </Route>
            <Route exact path="/remove-class">
              <RemoveClass />
            </Route>
            <Route exact path="/add-result">
              <AddResult />
            </Route>
            <Route exact path="/add-result/:id">
              <StudentResult />
            </Route>
            <Route exact path="/reset-password">
              <ForgotPwd />
            </Route>
            <Route path="/404">
              <NotFound />
            </Route>
            <Redirect to="/404" />
          </Switch>
        </div>
    </ThemeProvider>
  );
}
// https://fullcalendar.io/
export default App;
